import { render, staticRenderFns } from "./ComponentResourceGuard.vue?vue&type=template&id=ef9a6ea0&"
import script from "./ComponentResourceGuard.vue?vue&type=script&lang=ts&"
export * from "./ComponentResourceGuard.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports